import { render } from "./bubbleMedicine.vue?vue&type=template&id=50ff1004&scoped=true"
import script from "./bubbleMedicine.vue?vue&type=script&lang=js"
export * from "./bubbleMedicine.vue?vue&type=script&lang=js"

import "./bubbleMedicine.vue?vue&type=style&index=0&id=50ff1004&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-50ff1004"

export default script